module.exports = __webpack_public_path__ + "static/media/star_3.540693bf.svg";